var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotVerifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0.171 0.171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_copy_5",
    "data-name": "Layer 1 copy 5",
    transform: "translate(0.221 0.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_35",
    "data-name": 35,
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 44,
    height: 44,
    rx: 22,
    transform: "translate(-0.392 -0.392)",
    fill: "#ef6f6f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(8.242 7.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M124.177,95.241a1.712,1.712,0,0,0-1.885-1.45,13.027,13.027,0,0,1-7.624-1.266,9.054,9.054,0,0,1-2.507-1.861,1.677,1.677,0,0,0-2.644,0,9.016,9.016,0,0,1-2.507,1.861,13.028,13.028,0,0,1-7.624,1.266,1.712,1.712,0,0,0-1.885,1.45,28.4,28.4,0,0,0,.479,9.507c1.544,6.786,5.609,11.423,11.742,13.413a3.652,3.652,0,0,0,2.233,0c6.14-1.986,10.2-6.623,11.743-13.409a28.422,28.422,0,0,0,.479-9.511Zm-3.838,8.84c-1.3,5.57-4.47,9.21-9.436,10.817a.25.25,0,0,1-.123,0c-4.966-1.608-8.141-5.247-9.436-10.817a25.456,25.456,0,0,1-.582-6.768A15.281,15.281,0,0,0,110.838,94.1a15.207,15.207,0,0,0,9.666,3.221c.136,0,.275,0,.414-.005a25.562,25.562,0,0,1-.582,6.768Z",
    transform: "translate(-97.304 -90.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M215.685,201.615a1.712,1.712,0,0,0-2.422,0l-1.169,1.165-1.169-1.165a1.713,1.713,0,0,0-2.422,2.422l1.169,1.169-1.169,1.168a1.713,1.713,0,1,0,2.422,2.423l1.169-1.173,1.169,1.169a1.713,1.713,0,1,0,2.422-2.423l-1.169-1.168,1.169-1.169A1.713,1.713,0,0,0,215.685,201.615Z",
    transform: "translate(-198.56 -191.639)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotVerifiedIcon);
export default __webpack_public_path__ + "static/media/not_verified_icon.b670bb44843b03e88d3587bf6d5eb998.svg";
export { ForwardRef as ReactComponent };